import { FileData } from '@/interfaces';
import { DefaultEntity, ReportParams, ShotgunReportEntity } from '@/types';
import APIService from './axios.service';
import { BaseService } from './base.service';

class ShotgunReportService extends BaseService<
  'shotgunReport',
  ShotgunReportEntity,
  DefaultEntity
> {
  constructor() {
    super('kits/reports');
  }

}

export const shotgunReportService = new ShotgunReportService();
